import { createContext, useEffect, useState } from "react";

const DEFAULT_LANGUAGE = "es";

const getRegionIpAPI = async () => {
  const res = await fetch("http://ip-api.com/json/");

  return await res.json();
};

export const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(DEFAULT_LANGUAGE);

  useEffect(() => {
    const localStorageLanguage = localStorage.getItem("lang");
    if (localStorageLanguage) {
      setLanguage(localStorageLanguage);
    } else {
      getRegionIpAPI()
        .then(({ country }) => {
          const itsArg = country === "Argentina";
          setLanguage(itsArg ? "es" : "en");
        })
        .catch((err) => {
          console.log("ERROR", err);
        });
    }
  }, []);

  useEffect(() => {
    localStorage.setItem("lang", language);
  }, [language]);

  return (
    <LanguageContext.Provider value={language}>
      {children}
    </LanguageContext.Provider>
  );
};
